import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
// import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApiInterceptor } from './services/api-interceptors.service';
import { initializeApp } from './services/initialize-app.service';
import { TokenService } from './services/token.service';
import { UserSessionService } from './services/user-session.service';
import { UtilService } from './services/util.service';
import { ConstantService } from './services/constant.service';
import { EncryptionService } from './services/encryption.service';
import { SessionStorageService } from './services/session-storage.service';
import { CommonService } from './services/common.service';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [
        TokenService,
        CommonService,
        SessionStorageService,
        UserSessionService,
        UtilService,
        ConstantService,
        EncryptionService,
      ],
      multi: true,
    },

    provideHttpClient(withInterceptors([ApiInterceptor])),
    // provideAnimations(),
    DatePipe,provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes)]
};
